/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Very_Short_Minute_Unit_LowercaseInputs */

const en_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const ar_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const de_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const es_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const fr_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const it_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const ja_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const ko_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분`)
};

const pt_br_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const ru_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мин.`)
};

const th_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น`)
};

const tr_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dk`)
};

const zh_cn_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const zh_tw_very_short_minute_unit_lowercase = /** @type {(inputs: Very_Short_Minute_Unit_LowercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

/**
* | output |
* | --- |
* | "m" |
*
* @param {Very_Short_Minute_Unit_LowercaseInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const very_short_minute_unit_lowercase = /** @type {((inputs?: Very_Short_Minute_Unit_LowercaseInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Very_Short_Minute_Unit_LowercaseInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_very_short_minute_unit_lowercase(inputs)
	if (locale === "ar") return ar_very_short_minute_unit_lowercase(inputs)
	if (locale === "de") return de_very_short_minute_unit_lowercase(inputs)
	if (locale === "es") return es_very_short_minute_unit_lowercase(inputs)
	if (locale === "fr") return fr_very_short_minute_unit_lowercase(inputs)
	if (locale === "it") return it_very_short_minute_unit_lowercase(inputs)
	if (locale === "ja") return ja_very_short_minute_unit_lowercase(inputs)
	if (locale === "ko") return ko_very_short_minute_unit_lowercase(inputs)
	if (locale === "pt_br") return pt_br_very_short_minute_unit_lowercase(inputs)
	if (locale === "ru") return ru_very_short_minute_unit_lowercase(inputs)
	if (locale === "th") return th_very_short_minute_unit_lowercase(inputs)
	if (locale === "tr") return tr_very_short_minute_unit_lowercase(inputs)
	if (locale === "zh_cn") return zh_cn_very_short_minute_unit_lowercase(inputs)
	return zh_tw_very_short_minute_unit_lowercase(inputs)
});